import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

const originalAddEventListener = EventTarget.prototype.addEventListener;

EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
): void {
    const passiveEvents = ["touchstart", "touchmove", "wheel"];

    if (passiveEvents.includes(type) && (options === undefined || options === false)) {
        const newOptions: AddEventListenerOptions = {
            passive: true,
        };

        return originalAddEventListener.call(this, type, listener, newOptions);
    }

    return originalAddEventListener.call(this, type, listener, options);
};

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
